import type { Messages } from "./en";

export const de: Messages = {
  "nav.home": "LEARNABLE-Startseite",
  "nav.main": "Hauptmenü",
  "nav.courses": "Kurse",
  "nav.review": "Wiederholen",
  "nav.progress": "Fortschritt",
  "nav.guide": "Anleitung",
  "nav.marketplace": "Marktplatz",
  "nav.streak": "Tagesserie: {n}",
  "nav.xp": "Gesamterfahrung: {n} XP",

  "account.menu": "Konto",
  "account.settings": "Einstellungen",
  "account.guide": "So funktioniert LEARNABLE",
  "account.signOut": "Abmelden",

  "common.save": "Speichern",
  "common.saved": "Gespeichert.",
  "common.saving": "Wird gespeichert…",
  "common.cancel": "Abbrechen",
  "common.close": "Schließen",
  "common.pleaseWait": "Bitte warten…",

  "signin.title": "Bei LEARNABLE anmelden",
  "signin.registerTitle": "Konto erstellen",
  "signin.email": "E-Mail",
  "signin.password": "Passwort",
  "signin.passwordRule": "Mindestens 12 Zeichen.",
  "signin.submit": "Anmelden",
  "signin.register": "Konto erstellen",
  "signin.forgot": "Passwort vergessen?",
  "signin.toRegister": "Neues Konto erstellen",
  "signin.toSignIn": "Ich habe schon ein Konto",
  "signin.language": "Sprache",

  "password.current": "Aktuelles Passwort",
  "password.new": "Neues Passwort (mindestens 12 Zeichen)",
  "password.change": "Passwort ändern",
  "password.changed": "Passwort geändert. Deine anderen Geräte wurden abgemeldet.",

  "settings.title": "Einstellungen",
  "settings.intro": "Dein Profil und deine Einstellungen. Sie werden in deinem Konto gespeichert und gelten auf allen Geräten.",
  "settings.profile": "Profil",
  "settings.displayName": "Anzeigename",
  "signin.emailOrUsername": "E-Mail oder Benutzername",
  "signin.username": "Benutzername (optional)",
  "signin.usernameHint": "3–30 Buchstaben, Ziffern, Punkte, Unterstriche oder Bindestriche. Damit kannst du dich statt mit der E-Mail anmelden.",
  "settings.username": "Benutzername",
  "settings.usernameHint": "Optional. Damit meldest du dich statt mit der E-Mail an. Andere sehen ihn nie. Leer lassen, um ihn zu entfernen.",
  "settings.displayNameHint": "Wird statt deiner E-Mail angezeigt. Leer lassen, um die E-Mail zu verwenden.",
  "settings.email": "E-Mail",
  "settings.emailHint": "Die Adresse, mit der du dich anmeldest.",
  "settings.language": "Sprache",
  "settings.languageHint": "Die Sprache der Menüs und Seiten. Deine Kursinhalte und das Feedback der KI bleiben in der Sprache des Kurses.",
  "settings.translationNote": "Die Übersetzung läuft: Einige Bildschirme sind noch auf Englisch.",
  "settings.study": "Lernen",
  "settings.timezone": "Zeitzone",
  "settings.timezoneHint": "Dein Lerntag, deine Serie und dein Tagesziel richten sich nach dieser Zeitzone.",
  "settings.dailyGoal": "Tagesziel",
  "settings.dailyGoalHint": "Antworten pro Tag.",
  "settings.security": "Sicherheit",
  "settings.signOutHint": "Beim Abmelden werden die Daten deines Kontos aus diesem Browser entfernt.",

  "guide.title": "So funktioniert LEARNABLE",
  "guide.intro": "LEARNABLE macht aus deinem eigenen Lernmaterial Fragen, prüft deine Antworten und plant jede Wiederholung kurz bevor du etwas vergessen würdest.",
  "guide.contents": "Inhalt",
  "guide.structure.title": "1. Wie ein Kurs aufgebaut ist",
  "guide.structure.body": "Ein Kurs ist in Kapitel unterteilt, Kapitel in Themen und Themen in Konzepte. Jedes Konzept enthält Lerneinheiten: die Fakten, die du dir merken sollst, jeweils mit einer oder mehreren Fragen abgefragt.",
  "guide.material.title": "2. Material hinzufügen",
  "guide.material.body": "Öffne einen Kurs und lade PDF-, Word-, PowerPoint-, Text- oder Markdown-Dateien hoch oder füge Text ein. Wenn du schon Fragen und Antworten hast, lade sie mit Zeilen hoch, die mit \"Question:\" und \"Answer:\" (oder \"Domanda:\" und \"Risposta:\") beginnen: Jede wird ohne KI zu einem Konzept.",
  "guide.curriculum.title": "3. Lehrplan erstellen",
  "guide.curriculum.body": "Lass die KI aus deinem Material Kapitel, Themen und Konzepte vorschlagen. Prüfe den Vorschlag, benenne um, verschiebe oder entferne, was du willst, und übernimm ihn dann. Bis dahin ändert sich nichts.",
  "guide.study.title": "4. Ein Konzept lernen",
  "guide.study.body": "Öffne ein Konzept und tippe auf Aktivieren: Die Lerneinträge werden aus deinem Material vorbereitet. Lies sie und tippe dann auf „Ich habe dieses Konzept gelernt“. Jede Frage wird so lange gestellt, bis du sie dreimal gut beantwortet hast (nicht unbedingt hintereinander), mit Feedback nach jeder Antwort.",
  "guide.answer.title": "5. Antworten und Feedback erhalten",
  "guide.answer.body": "Schreib deine Antwort in eigenen Worten oder drücke \"Antwort sprechen\", um sie zu diktieren. Ein Hinweis ist verfügbar, halbiert aber die XP. Die KI bewertet die Bedeutung, nicht den genauen Wortlaut, und zeigt vier Werte und eine Liste mit Richtigem, Fehlendem und Falschem. Die Musterantwort und ihre Quellen sind immer nur einen Klick entfernt.",
  "guide.disagree.title": "6. Wenn du nicht einverstanden bist",
  "guide.disagree.body": "Drücke \"Disagree with the grade?\". Du kannst begründen, warum, und die KI um eine zweite Meinung bitten (beide bleiben sichtbar), oder die Antwort selbst bewerten. Deine eigene Bewertung gilt immer.",
  "guide.review.title": "7. Rechtzeitig wiederholen",
  "guide.review.body": "Jede Antwort setzt ihre Frage in einen Zeitplan: Je besser du sie kannst, desto später kommt sie wieder. Die Seite Wiederholen und dein Dashboard zeigen, was fällig ist und wie lange es ungefähr dauert.",
  "guide.progress.title": "8. Fortschritt verfolgen",
  "guide.progress.body": "Deine Serie zählt die Tage, an denen du gelernt hast, XP belohnen richtige Antworten und das Tagesziel bestimmt dein Tempo. \"Was du immer wieder falsch machst\" sammelt die Fehler aus deinen letzten Antworten, mit einer Schaltfläche zum Üben.",
  "guide.organise.title": "9. Ordnung halten",
  "guide.organise.body": "Unter \"Fragen verwalten\" kannst du einzelne Fragen oder ganze Kapitel, Themen und Konzepte auswählen, um sie zu löschen, zu pausieren, fortzusetzen oder zu verschieben, eine Frage bearbeiten und ⠿ ziehen, um die Reihenfolge zu ändern. Lange Abschnitte lassen sich mit dem Pfeil neben dem Titel einklappen.",
  "guide.marketplace.title": "10. Kurse teilen und bekommen",
  "guide.marketplace.body": "Im Marktplatz findest du Kurse anderer Nutzer, nach Kategorie, Niveau, Sprache und Umfang. Bevor du einen hinzufügst, siehst du seine Seite: was er behandelt, für wen er ist, was du lernst, seine Kapitel und wie viele Fragen er hat. \"Zu meinen Kursen hinzufügen\" legt ihn auf dein Dashboard: Der Autor hält die Fragen aktuell und du kannst sie nicht bearbeiten, aber dein Lernen gehört dir (dein Plan, deine Antworten, deine XP und die Priorität, die du jeder Frage gibst). Das Material des Autors kann nicht heruntergeladen werden. Um einen eigenen Kurs zu teilen, öffne ihn, schreibe seine \"Marktplatz-Seite\", speichere sie als Entwurf und veröffentliche sie dann.",
  "guide.glossary.title": "Begriffe in der App",
  "guide.term.concept": "Konzept",
  "guide.term.concept.def": "Eine Idee deines Kurses, etwa eine Definition oder eine Regel.",
  "guide.term.item": "Lerneinheit",
  "guide.term.item.def": "Ein Fakt in einem Konzept, mit seinen Fragen und der erwarteten Antwort.",
  "guide.term.active": "Active (aktiv)",
  "guide.term.active.def": "Das Konzept nimmt am Lernen und Wiederholen teil. Pausierte oder nicht gelernte Konzepte nicht.",
  "guide.term.grades": "Nochmal · Schwer · Gut · Leicht",
  "guide.term.grades.def": "Nochmal, schwer, gut, leicht: wie gut du die Antwort wusstest. Davon hängt ab, wann die Frage wiederkommt.",
  "guide.term.mastery": "Beherrschung",
  "guide.term.mastery.def": "Eine Schätzung, wie gut du dich an ein Konzept erinnerst, aus deinen Wiederholungen.",
  "guide.term.xp": "XP und Serie",
  "guide.term.xp.def": "Punkte für richtige Antworten und die Zahl der Tage in Folge, an denen du gelernt hast.",
  "guide.privacy.title": "Deine Daten",
  "guide.privacy.body": "Deine Kurse, Antworten und Fortschritte siehst nur du. Diktate werden von deinem Browser transkribiert; gespeichert wird nur der Text.",
  "help.button": "Hilfe: {topic}",
  "help.more": "Mehr erfahren",
  "help.nextStep": "Das Nützlichste, was du jetzt tun kannst. Fällige Wiederholungen kommen immer zuerst, dann neuer Stoff.",
  "help.courses": "Eine Karte pro Kurs. Der grüne Knopf wiederholt das Fällige, der blaue macht mit Neuem weiter.",
  "help.streak": "Tage in Folge mit mindestens einer Antwort. Beantworte heute eine Frage, damit die Serie hält.",
  "help.xp": "Erfahrungspunkte für richtige Antworten. Ein Hinweis halbiert sie.",
  "help.goal": "Wie viele Antworten du pro Tag geben willst. Du kannst es in den Einstellungen ändern.",
  "help.planner": "Wie viele Fragen bis zu welchem Zeitpunkt fällig werden und wie lange sie ungefähr dauern.",
  "help.coursePlanner": "Nur dieser Kurs: wie viele seiner Fragen wann fällig werden und wie lange sie ungefähr dauern. Neues Material braucht mindestens drei gute Antworten pro Frage.",
  "help.activity": "Ein Quadrat pro Tag: je dunkler, desto mehr hast du geantwortet.",
  "help.concept": "Ein Konzept ist eine Idee deines Kurses. Beginne damit, um seine Fragen vorzubereiten, lies seine Lerneinheiten und übe sie dann.",
  "help.consolidate": "Tippe auf die Schaltfläche, wenn du die Lerneinträge unten gelesen hast. Jede Frage wird so lange gestellt, bis du sie dreimal gut beantwortet hast, damit es sitzt.",
  "help.study": "Schreib die Antwort in eigenen Worten oder diktiere sie. Die KI prüft die Bedeutung, nicht den Wortlaut, und zeigt, was richtig war oder fehlte.",
  "help.questions": "Markiere einzelne Fragen oder ein ganzes Kapitel, Thema oder Konzept und lösche, pausiere oder verschiebe sie. Zieh ⠿, um die Reihenfolge zu ändern.",
  "help.marketplace": "Kurse anderer Nutzer. Öffne einen, um zu sehen, was er behandelt und wie viele Fragen er hat; füge ihn hinzu, um ihn mit deinem eigenen Plan zu lernen. Der Autor hält ihn aktuell.",
  "help.weakSpots": "Fehler aus deinen letzten Antworten, nach Konzept gruppiert. Übe sie, bis sie aus dieser Liste verschwinden.",
  "help.material": "Lade PDF-, Word-, PowerPoint- oder Textdateien hoch oder füge Text ein. LEARNABLE baut daraus den Kurs und seine Fragen.",
  "start.title": "So funktioniert LEARNABLE",
  "start.intro": "Vier Schritte. Öffne einen, um ihn in der Anleitung zu sehen.",
  "start.hide": "Verstanden, ausblenden",
  "start.reopen": "Zeigen, wie LEARNABLE funktioniert",
  "start.material.title": "Material hinzufügen",
  "start.material.body": "Erstelle einen Kurs und lade Notizen, Folien oder Bücher hoch oder füge Text ein.",
  "start.plan.title": "Plan bestätigen",
  "start.plan.body": "Die KI schlägt Kapitel und Konzepte vor. Ändere, was du willst, und übernimm ihn.",
  "start.study.title": "Lernen und antworten",
  "start.study.body": "Lies ein Konzept und beantworte dann seine Fragen in eigenen Worten oder per Sprache.",
  "start.review.title": "Rechtzeitig wiederholen",
  "start.review.body": "Fragen kommen kurz bevor du sie vergessen würdest wieder. Folge dem grünen Knopf.",
  "nav.community": "Community",
  "community.title": "Community",
  "community.intro": "Sieh, wer die meiste Erfahrung sammelt, folge anderen Lernenden und feuere sie an.",
  "community.tab.leaderboard": "Rangliste",
  "community.tab.friends": "Freunde",
  "community.period": "Zeitraum",
  "community.scope": "Wer",
  "community.period.day": "Heute",
  "community.period.week": "Diese Woche",
  "community.period.month": "Dieser Monat",
  "community.period.all": "Gesamt",
  "community.scope.everyone": "Alle",
  "community.scope.friends": "Freunde",
  "community.leader": "Spitzenreiter",
  "community.xp": "{n} XP",
  "community.you": "Du",
  "community.yourPlace": "Dein Platz",
  "community.empty": "In diesem Zeitraum hat noch niemand XP gesammelt.",
  "community.emptyFriends": "Folge anderen Lernenden, um dich hier mit ihnen zu vergleichen.",
  "community.windowNote": "Tage richten sich nach UTC; Wochen beginnen am Montag. Es erscheinen nur Personen, die der Community beigetreten sind.",
  "community.joinTitle": "Tritt der Community bei",
  "community.joinText": "Du bist noch nicht in der Rangliste. Aktiviere die Sichtbarkeit in der Community, um dort aufzutauchen, gefunden und verfolgt zu werden. Andere sehen nur deinen Anzeigenamen und deine XP, nie deine E-Mail.",
  "community.joinButton": "Mich in der Community anzeigen",
  "community.needName": "Wähle zuerst in den Einstellungen einen Anzeigenamen.",
  "community.follow": "Folgen",
  "community.following": "Folge ich",
  "community.friend": "Freunde",
  "community.followsYou": "Folgt dir",
  "community.since": "Lernt hier seit {date}",
  "community.statXpTotal": "XP gesamt",
  "community.statXpWeek": "XP diese Woche",
  "community.statStreak": "Tage in Folge",
  "community.statFollowers": "Follower",
  "community.statFollowing": "Folge ich",
  "community.followingList": "Personen, denen du folgst",
  "community.followersList": "Deine Follower",
  "community.searchLabel": "Lernende nach Namen suchen",
  "community.searchPlaceholder": "Nach Anzeigenamen suchen",
  "community.search": "Suchen",
  "community.noResults": "Niemand gefunden. Es sind nur Personen auffindbar, die der Community beigetreten sind.",
  "community.noFollowing": "Du folgst noch niemandem.",
  "community.noFollowers": "Noch keine Follower.",
  "community.streakDays": "{n} Tage in Folge",
  "community.xpToday": "{n} XP heute",
  "community.notFound": "Dieses Profil ist nicht verfügbar.",
  "community.seeLeaderboard": "Community-Rangliste ansehen",
  "course.leaderboardLink": "Kursrangliste",
  "course.leaderboardTitle": "Kursrangliste",
  "course.leaderboardIntro": "In diesem Kurs von allen gesammelte XP.",
  "course.leaderboardPrivate": "Dies ist ein privater Kurs, daher bist nur du in seiner Rangliste. Kurse aus dem Marketplace werden mit allen geteilt, die sie haben.",
  "course.leaderboardParticipants": "{n} Lernende teilen diesen Kurs.",
  "settings.community": "Community",
  "settings.communityToggle": "Mich in der Community anzeigen (Ranglisten, Suche und Folgen)",
  "settings.communityHint": "Standardmäßig aus. Andere sehen nur deinen Anzeigenamen, deine XP und deine Serie, nie deine E-Mail, Kurse oder Antworten. Zum Aktivieren brauchst du einen Anzeigenamen.",
  "study.repeat.badge": "Fast: wiederhole sie",
  "study.repeat.title": "Lies die Referenzantwort und wiederhole sie dann",
  "study.repeat.body": "Deine Antwort war in den meisten Punkten stark. Lies die Referenzantwort oben und schreibe sie noch einmal in eigenen Worten. Gelingt sie, zählt sie als richtige Antwort und dein Plan geht vorwärts. Sonst fällt der Eintrag auf Stufe null zurück.",
  "study.repeat.label": "Deine Antwort, noch einmal",
  "study.repeat.submit": "Wiederholen",
  "study.repeat.selfGrade": "Stattdessen selbst bewerten",
  "study.repeat.evalTitle": "Deine Wiederholung",
  "error.generic": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
  "error.transport": "Der Server ist nicht erreichbar. Prüfe deine Verbindung und versuche es erneut.",
  "error.session": "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.",
  "error.validation": "Einige der eingegebenen Angaben sind ungültig.",
  "error.notFound": "Dieses Element existiert nicht mehr.",
  "error.tooLarge": "Diese Datei ist zu groß.",
  "error.unsupported": "Dieser Dateityp wird nicht unterstützt. Verwende PDF-, Word-, PowerPoint-, Text- oder Markdown-Dateien.",
  "error.aiNotConfigured": "Die KI ist auf dem Server noch nicht eingerichtet.",
  "error.aiUnavailable": "Die KI ist vorübergehend nicht verfügbar. Bitte versuche es später erneut.",
  "error.aiInvalid": "Die KI hat eine unbrauchbare Antwort geliefert. Bitte versuche es erneut.",
  "error.state": "Diese Aktion ist im aktuellen Zustand nicht möglich.",
  "error.server": "Auf dem Server ist etwas schiefgelaufen. Bitte versuche es erneut.",
  "error.rateLimited": "Zu viele Versuche. Bitte warte einen Moment und versuche es erneut.",
  "error.managedCourse": "Dieser Kurs stammt aus dem Marketplace: Sein Autor hält ihn aktuell, daher kann sein Inhalt hier nicht geändert werden.",
  "studyState.NOT_STUDIED": "Nicht gelernt",
  "studyState.STUDIED": "Gelernt",
  "studyState.ACTIVE": "Aktiv",
  "studyState.PAUSED": "Pausiert",
  "studyState.COMPLETED": "Abgeschlossen",
  "memoryState.NEW": "Neu",
  "memoryState.LEARNING": "Wird gelernt",
  "memoryState.REVIEW": "In Wiederholung",
  "memoryState.RELEARNING": "Wird neu gelernt",
  "memoryState.MASTERED": "Gemeistert",
  "outcome.AGAIN": "Nochmal",
  "outcome.HARD": "Schwer",
  "outcome.GOOD": "Gut",
  "outcome.EASY": "Leicht",
  "outcomeHelp.AGAIN": "Ich wusste es nicht",
  "outcomeHelp.HARD": "Ich wusste es, mit Mühe",
  "outcomeHelp.GOOD": "Ich wusste es",
  "outcomeHelp.EASY": "Ich wusste es mühelos",
  "classification.CORRECT": "Richtig",
  "classification.PARTIALLY_CORRECT": "Teilweise richtig",
  "classification.MISCONCEPTION": "Missverständnis",
  "classification.WRONG": "Nicht richtig",
  "classification.UNCERTAIN": "Unsicher",
  "role.CORE_TRAINABLE": "Kern",
  "role.SUPPORTING_TRAINABLE": "Unterstützend",
  "role.COMMON_TRAP": "Häufige Falle",
  "role.INFORMATIONAL": "Informativ",
  "role.REFERENCE": "Referenz",
  "role.OPTIONAL_EXTENSION": "Optional",
  "priority.1": "Wesentlich",
  "priority.2": "Wichtig",
  "priority.3": "Extra",
  "label.page": "Seite {n}",
  "label.pages": "Seiten {a}–{b}",
  "label.pageShort": "S. {n}",
  "label.pagesShort": "S. {a}–{b}",
  "category.law": "Recht",
  "category.economics_business": "Wirtschaft & Unternehmen",
  "category.accounting_finance": "Rechnungswesen & Finanzen",
  "category.medicine_health": "Medizin & Gesundheit",
  "category.sciences": "Naturwissenschaften",
  "category.mathematics": "Mathematik",
  "category.engineering": "Ingenieurwesen",
  "category.computer_science": "Informatik",
  "category.languages": "Sprachen",
  "category.humanities": "Geschichte & Geisteswissenschaften",
  "category.arts": "Kunst & Musik",
  "category.professional_exams": "Berufsprüfungen",
  "category.other": "Sonstiges",
  "level.all": "Alle Niveaus",
  "level.beginner": "Anfänger",
  "level.intermediate": "Fortgeschritten",
  "level.advanced": "Experte",
  "size.small": "Kurz (unter 50 Fragen)",
  "size.medium": "Mittel (50–299 Fragen)",
  "size.large": "Groß (300+ Fragen)",
  "sort.popular": "Am beliebtesten",
  "sort.newest": "Neueste",
  "sort.largest": "Meiste Fragen",
  "lang.it": "Italienisch",
  "lang.en": "Englisch",
  "price.free": "Kostenlos",
  "common.loading": "Wird geladen…",
  "common.tryAgain": "Erneut versuchen",
  "common.dismiss": "Schließen",
  "common.delete": "Löschen",
  "common.edit": "Bearbeiten",
  "common.rename": "Umbenennen",
  "common.title": "Titel",
  "common.description": "Beschreibung",
  "common.continue": "Weiter",
  "common.search": "Suchen",
  "common.add": "Hinzufügen",
  "common.remove": "Entfernen",
  "common.yes": "Ja",
  "common.no": "Nein",
  "common.collapse": "{label} einklappen",
  "common.expand": "{label} ausklappen",
  "drag.item": "Element",
  "drag.reorder": "{label} neu anordnen",
  "drag.pickedUp": "{label} aufgenommen, Position {pos} von {total}.",
  "drag.over": "{label} steht jetzt auf Position {pos} von {total}.",
  "drag.dropped": "{label} auf Position {pos} von {total} abgelegt.",
  "drag.droppedPlain": "{label} abgelegt.",
  "drag.cancelled": "Verschieben von {label} abgebrochen.",
  "drawing.loadFailed": "Die Zeichnung konnte nicht geladen werden.",
  "course.authorOrder": "Die Reihenfolge dieses Kurses legt der Autor fest.",
  "priority.yours": "Deine Priorität",
  "priority.label": "Priorität",
  "priority.author": "Autor: {name}",
  "priority.useAuthor": "Die des Autors verwenden",
  "editTitle.rename": "{label} umbenennen",
  "label.course": "Kurs",
  "label.chapter": "Kapitel",
  "label.topic": "Thema",
  "label.concept": "Konzept",
  "library.heading": "Meine Kurse",
  "library.count.one": "{n} Kurs",
  "library.count.other": "{n} Kurse",
  "library.shownOf": "{shown} von {total} angezeigt",
  "library.search": "Kurse suchen",
  "library.show": "Anzeigen",
  "library.sortBy": "Sortieren nach",
  "library.new": "+ Neuer Kurs",
  "library.marketplace": "🛒 Marktplatz",
  "library.empty": "Noch keine Kurse. Erstelle einen und füge dann dein Lernmaterial oder deine eigenen Fragen und Antworten hinzu.",
  "library.createFirst": "Erstelle deinen ersten Kurs",
  "library.noMatch": "Kein Kurs passt zu dieser Suche oder diesem Filter.",
  "libStatus.all": "Alle Kurse",
  "libStatus.in_progress": "In Bearbeitung",
  "libStatus.not_started": "Nicht begonnen",
  "libStatus.due": "Fällige Wiederholungen",
  "libStatus.completed": "Nichts Neues zu lernen",
  "libStatus.paused": "Pausiert",
  "libStatus.archived": "Archiviert",
  "libSort.recent_study": "Zuletzt gelernt",
  "libSort.recent_created": "Zuletzt erstellt",
  "libSort.alphabetical": "Alphabetisch",
  "libSort.most_due": "Meiste fällige Wiederholungen",
  "card.marketplacePill": "🛒 Aus dem Marktplatz · von {author}",
  "card.marketplaceHint": "Der Autor hält den Inhalt aktuell; dein Lernen gehört dir.",
  "card.continue": "Weiter",
  "card.next": "Nächstes",
  "card.archived": "Archiviert",
  "card.paused": "Pausiert",
  "card.conceptsStudied": "Konzepte gelernt",
  "card.itemsIntroduced": "Lerneinheiten eingeführt",
  "card.moreFor": "Mehr für {title}",
  "menu.details": "Kursdetails",
  "menu.material": "Lernmaterial",
  "menu.progress": "Fortschritt",
  "menu.publish": "🛒 Im Marktplatz veröffentlichen",
  "menu.pause": "Pausieren",
  "menu.resume": "Fortsetzen",
  "menu.archive": "Archivieren",
  "menu.restore": "Wiederherstellen",
  "menu.delete": "Löschen…",
  "menu.confirmOwn": "\"{title}\" löschen? Kapitel, Fragen, Material und deine Antworten werden endgültig gelöscht. Archiviere ihn stattdessen, um alles zu behalten.",
  "menu.confirmMarketplace": "\"{title}\" löschen? Du kannst ihn kostenlos wieder aus dem Marktplatz hinzufügen.",
  "newCourse.aria": "Neuer Kurs",
  "newCourse.language": "Sprache des Materials",
  "newCourse.create": "Kurs erstellen",
  "learn.resume.label": "Übung fortsetzen",
  "learn.resume.hint": "Setze die unterbrochene Runde fort",
  "learn.study.label": "Als Nächstes lernen",
  "learn.study.hint": "{title} lernen",
  "learn.study.hintNone": "Neues Material lernen",
  "learn.activate.label": "Mit dem Lernen beginnen",
  "learn.activate.hint": "Bereite die Fragen zu {title} vor und beginne damit",
  "learn.activate.hintNone": "Beginne mit dem nächsten Konzept",
  "learn.setup.label": "Material hinzufügen",
  "learn.setup.hint": "Füge Lernmaterial oder eigene Fragen hinzu, um zu beginnen",
  "learn.none.label": "Alles gelernt ✓",
  "learn.none.hint": "Alles in diesem Kurs wurde gelernt",
  "review.none": "✓ Jetzt nichts zu wiederholen",
  "review.noneTitle": "Im Moment muss in diesem Kurs nichts wiederholt werden",
  "review.aria.one": "{n} Element wiederholen",
  "review.aria.other": "{n} Elemente wiederholen",
  "review.button": "Wiederholen",
  "course.practiceHard": "Schwere Fragen üben",
  "course.chapters": "Kapitel",
  "course.chaptersEmpty": "Füge ein Kapitel hinzu und danach Lernmaterial.",
  "course.chapterMeta": "{active} von {total} Konzepten aktiv · Beherrschung {mastery}",
  "course.newChapter": "Titel des neuen Kapitels",
  "course.addChapter": "Kapitel hinzufügen",
  "course.curriculum": "Lehrplan",
  "course.fallback": "Kurs",
  "course.allMaterial": "Gesamtes Lernmaterial",
  "course.manageQuestions": "Fragen verwalten",
  "course.weakSpots": "Was du immer wieder falsch machst",
  "chapter.gone": "Dieses Kapitel existiert nicht mehr.",
  "chapter.topics": "Themen",
  "chapter.starting": "Analyse wird gestartet…",
  "chapter.analyze": "Neues Material analysieren",
  "chapter.analyzeHint": "Die KI schlägt Themen und Konzepte aus noch nicht analysiertem Material vor. Du prüfst den Vorschlag, bevor sich etwas ändert.",
  "chapter.noMaterial": "In diesem Kapitel gibt es kein neues Material zu analysieren. Lade zuerst Material hoch.",
  "chapter.empty": "Noch keine Themen. Lade unten Material hoch und analysiere es dann.",
  "chapter.topicMeta": "{active} von {total} Konzepten aktiv",
  "topic.gone": "Dieses Thema existiert nicht mehr.",
  "topic.concepts": "Konzepte",
  "topic.empty": "Keine Konzepte in diesem Thema.",
  "topic.needsReview": "Quelle prüfen",
  "topic.conceptMeta": "{state} · Beherrschung {mastery}",
  "unit.item.one": "{n} Element",
  "unit.item.other": "{n} Elemente",
  "unit.answer.one": "{n} Antwort",
  "unit.answer.other": "{n} Antworten",
  "consolidate.continue": "Festigung fortsetzen",
  "consolidate.unfinished": "Dein Stapel mit {items} ist nicht abgeschlossen: noch {left}. Bereits gegebene Antworten bleiben erhalten.",
  "consolidate.resume": "Fortsetzen",
  "consolidate.doneTitle": "Gefestigt",
  "consolidate.doneBody": "Jedes Element dieses Konzepts hatte seine Festigungsrunden. Sie kommen in deinen Wiederholungen zurück, wenn sie fällig sind.",
  "consolidate.title": "Konzept gelernt?",
  "consolidate.body": "Lies zuerst oben, was zu lernen ist. Wenn du bereit bist, wird jede Frage so lange gestellt, bis du sie {n} Mal gut beantwortet hast (nicht unbedingt hintereinander), mit Feedback nach jeder Antwort.",
  "consolidate.batch": "Dieser Stapel: {items} · {answers}",
  "consolidate.more.one": "{n} weiteres Element wartet auf einen späteren Stapel",
  "consolidate.more.other": "{n} weitere Elemente warten auf einen späteren Stapel",
  "consolidate.button": "Ich habe dieses Konzept gelernt",
  "breadcrumb.aria": "Brotkrumen-Navigation",
  "dash.title": "Dashboard",
  "dash.loading": "Dein Dashboard wird geladen…",
  "dash.aside": "Dein Lernen",
  "dash.today": "Heute",
  "dash.xpTodayPlus": "+{n} XP heute",
  "dash.goal": "Ziel {done}/{target}",
  "dash.tzNote": "Deine Lerntage (Serie, Ziel, XP heute) folgen {zone}. Dieses Gerät steht auf {device}.",
  "dash.tzUse": "{zone} verwenden",
  "next.title": "Dein nächster Schritt",
  "next.resumeTitle": "Festigung fortsetzen · Gute Antwort {round} von {total}",
  "next.answersLeft": "{n} Antworten übrig",
  "next.resume": "Fortsetzen",
  "next.minutes": "etwa {n} Min.",
  "next.startReview": "Wiederholung starten",
  "next.learnTitle": "Weiterlernen: {concept}",
  "next.nextConcept": "nächstes Konzept",
  "next.learn": "Lernen",
  "next.setupTitle": "{concept} einrichten",
  "next.theNextConcept": "das nächste Konzept",
  "next.setupDetail": "{course} · aktiviere es, um die Fragen vorzubereiten",
  "next.setup": "Einrichten",
  "next.addMaterialTitle": "Füge {course} Material hinzu",
  "next.yourCourse": "deinen Kurs",
  "next.addMaterialDetail": "Lade Lernmaterial oder eigene Fragen und Antworten hoch, um die Konzepte aufzubauen.",
  "next.firstCourse": "Starte deinen ersten Kurs",
  "next.firstCourseDetail": "Erstelle einen Kurs und füge dann Material oder eigene Fragen hinzu.",
  "next.caughtUp": "Du bist auf dem neuesten Stand",
  "next.caughtUpDetail": "Nichts ist fällig und kein neues Material wartet.",
  "streak.title": "Tägliche Serie",
  "streak.unit.one": "Tag",
  "streak.unit.other": "Tage",
  "streak.done": "Heute geschafft. Komm morgen wieder, um weiterzumachen.",
  "streak.keep": "Beantworte heute eine Frage, um deine Serie zu halten.",
  "streak.start": "Beantworte heute eine Frage, um eine Serie zu starten.",
  "streak.last7": "Die letzten 7 Tage",
  "streak.studied": "gelernt",
  "streak.noStudy": "kein Lernen",
  "xp.title": "Erfahrung",
  "xp.how": "So funktionieren XP",
  "xp.howBody": "Jede richtige Antwort auf dasselbe Element bringt mehr: 10 XP beim ersten Mal, dann 20, 30… bis 150. Ein Hinweis halbiert die XP dieser Antwort. Falsche Antworten bringen nichts, setzen aber deinen Fortschritt nicht zurück. XP belohnen Übung; sie ändern nie deinen Wiederholungsplan.",
  "goal.title": "Tagesziel",
  "goal.sr": "Tagesziel: heute {done} von {target} Antworten abgeschlossen, {percent} Prozent.",
  "goal.answersToday": "{done} / {target} Antworten heute",
  "goal.perDay": "Antworten pro Tag",
  "goal.edit": "Ziel ändern",
  "goal.invalid": "Wähle eine ganze Zahl von 1 bis 500.",
  "planner.title": "Zeitplaner",
  "planner.now": "Jetzt",
  "planner.1h": "In 1 Stunde",
  "planner.4h": "In 4 Stunden",
  "planner.1d": "In 1 Tag",
  "planner.3d": "In 3 Tagen",
  "planner.7d": "In 7 Tagen",
  "planner.dueNow": "{n} jetzt fällig: etwa {min} Min.",
  "planner.caption": "Fällige Wiederholungen bis zu jedem Zeitpunkt, einschließlich überfälliger",
  "planner.dueBy": "Fällig bis",
  "planner.items": "Elemente",
  "planner.hint": "Basiert auf deinem aktuellen Wiederholungsplan; ändert sich beim Lernen. Jede Zeile enthält alles, was davor fällig ist.",
  "activity.title": "Aktivität",
  "activity.seeMore": "Mehr anzeigen",
  "activity.future": "{day}: in der Zukunft",
  "activity.day": "{day}: {answers}",
  "activity.dayXp": "{day}: {answers}, {xp} XP",
  "activity.aria": "Aktivitätskalender: {days}, {answers}",
  "activity.summary": "{days} · {answers}",
  "unit.activeDay.one": "{n} aktiver Tag",
  "unit.activeDay.other": "{n} aktive Tage",
  "activity.less": "Weniger",
  "activity.more": "Mehr",
  "activity.legendFuture": "Zukunft",
  "pb.curriculumHint": "Wie viel des Materials du gelernt und aktiviert hast.",
  "pb.conceptsActive": "Aktive Konzepte",
  "pb.activeOf": "{active} von {total}",
  "pb.memory": "Gedächtnis",
  "pb.memoryHint": "Wie gut du dir das Geübte merkst. Beherrschung ist eine Schätzung aus deinen Wiederholungen.",
  "pb.mastery": "Beherrschung (Schätzung)",
  "pb.itemsTrained": "Elemente im Training",
  "pb.markedHard": "Als schwer markiert",
  "pb.dueNow": "Jetzt fällig",
  "pb.laterToday": "Später heute",
  "pb.tomorrow": "Morgen",
  "pb.next7": "Nächste 7 Tage",
  "pb.newToLearn": "Neu zu lernen",
  "pb.overdue.one": "{n} Frage ist überfällig: beginne mit diesen.",
  "pb.overdue.other": "{n} Fragen sind überfällig: beginne mit diesen.",
  "pb.caption": "Bald fällige Fragen in diesem Kurs und ungefähre Dauer",
  "pb.when": "Wann",
  "pb.questions": "Fragen",
  "pb.time": "Zeit",
  "pb.minutes": "~{n} Min.",
  "study.intent.LEARN": "Lernen",
  "study.intent.SCHEDULED_REVIEW": "Wiederholung",
  "study.intent.PRACTICE": "Übung",
  "study.intent.EXAM": "Prüfung",
  "study.intent.CONSOLIDATION": "Festigung",
  "study.round": "Gute Antwort {n} von {total}",
  "study.progressAria": "Fortschritt in dieser Sitzung",
  "study.progress": "{n} von {total}",
  "study.xpSessionAria": "{n} XP in dieser Sitzung",
  "study.ownReview": "Eigene Wiederholung: keine Änderung an deinem Plan, keine XP",
  "study.leaveResume": "Verlassen (später fortsetzen)",
  "study.end": "Sitzung beenden",
  "study.preparing": "Deine Sitzung wird vorbereitet…",
  "study.empty.title": "Gerade nichts zu lernen",
  "study.empty.body": "Nichts passt zu dieser Sitzung. Aktiviere ein Konzept, um neues Material hinzuzufügen, oder komm wieder, wenn Wiederholungen fällig sind.",
  "study.empty.back": "Zurück zum Kurs",
  "study.newMaterial": "Neues Material",
  "study.keyPoints": "Kernpunkte",
  "study.sources": "Quellen",
  "study.ready": "Ich bin bereit: Frag mich ab",
  "study.answering": "Antworten",
  "study.drawHint": "Zeichne deine Antwort unten. Die KI vergleicht sie mit der Referenzzeichnung.",
  "study.note": "Notiz (optional)",
  "study.yourAnswer": "Deine Antwort",
  "study.notePlaceholder": "Etwas, das du zur Zeichnung ergänzen möchtest…",
  "study.answerPlaceholder": "Antworte in eigenen Worten…",
  "study.stopListening": "Zuhören beenden",
  "study.speak": "Antwort sprechen",
  "study.evaluating": "Wird ausgewertet…",
  "study.submit": "Absenden",
  "study.skip": "Diese Frage überspringen",
  "study.dictationOn": "Das Diktat wird von deinem Browser transkribiert, der das Audio an seinen Sprachdienst senden kann. Nur der Text wird gespeichert; bearbeite ihn vor dem Absenden.",
  "study.dictationOff": "Sprachantworten erfordern Chrome, Edge oder Safari. Du kannst deine Antwort hier tippen.",
  "study.drawingCompare": "Deine Zeichnung und die Referenz",
  "study.yourDrawing": "Deine Zeichnung",
  "study.reference": "Referenz",
  "study.gradedByYou": "Von dir bewertet",
  "study.needsGrade": "Braucht deine Bewertung",
  "study.firstEval": "Erste Auswertung",
  "study.secondOpinion": "Zweite Meinung",
  "study.afterObjection": "Nach deinem Einwand: „{text}“",
  "study.referenceSummary": "Referenzantwort und Quellen",
  "study.studyConcept": "📖 Dieses Konzept lernen",
  "study.gradeHow": "Wie gut wusstest du es?",
  "study.gradeYourself": "Oder bewerte selbst",
  "study.yourGrade": "Deine Bewertung",
  "study.retryEval": "Auswertung erneut versuchen",
  "study.skipNow": "Vorerst überspringen",
  "study.disagree": "Anderer Meinung als die Bewertung?",
  "study.notMemorized": "Noch nicht gemerkt: Du siehst es in dieser Sitzung wieder.",
  "study.levelNext": "Stufe {from} → {to}. Nächste Wiederholung: {when}",
  "study.practiceNote": "Übung ändert deinen Wiederholungsplan nicht.",
  "study.complete": "Sitzung abgeschlossen",
  "study.xpSessionPlus": "+{n} XP in dieser Sitzung",
  "study.answeredIn": "{answers} in etwa {min} Min.",
  "study.wentWell": "{n} liefen gut.",
  "study.steady": "Stetige Arbeit: Das sitzt langsam.",
  "study.comeBack": "Was schlecht lief, kommt bald wieder – so bleibt es hängen.",
  "study.stillDue": "Jetzt noch fällig: {n} (etwa {min} Min.).",
  "study.nothingDue": "Im Moment ist sonst nichts fällig.",
  "study.done": "Fertig",
  "study.noXp": "Diese Antwort bringt keine XP (Übung oder noch nicht zur Wiederholung fällig).",
  "study.correctXp": "Richtige Antwort: +{n} XP",
  "study.halfXp": "(Hinweis genutzt: halbe XP)",
  "study.hintLabel": "Hinweis",
  "study.noHint": "Kein Hinweis für diese Frage.",
  "study.showHint": "Hinweis anzeigen",
  "study.hintHalves": "Ein Hinweis halbiert die XP dieser Antwort.",
  "study.revealHint": "Hinweis aufdecken",
  "study.plusZero": "+0 XP",
  "study.onlyCorrectSelf": "Nur richtige Antworten bringen XP: Auch deine eigene Bewertung Schwer, Gut oder Leicht zählt.",
  "study.onlyCorrect": "Nur ganz richtige Antworten bringen XP. Dein Fortschritt zur nächsten Belohnung bleibt erhalten.",
  "study.awardCorrect": "Richtig",
  "study.awardHint": "Hinweis genutzt",
  "study.ordinal": "richtige Antwort Nr. {n} für dieses Element",
  "study.ordinalHalf": "richtige Antwort Nr. {n} für dieses Element, die Hälfte von {base}",
  "study.batchDone": "Stapel gefestigt",
  "study.correctAnswers": "Richtige Antworten",
  "study.xpThisSession": "XP in dieser Sitzung",
  "study.whatNext": "Wie es weitergeht",
  "study.whatNextBody": "Elemente, deren letzte Runde richtig war, kommen in etwa 4 Stunden zur Wiederholung zurück; die anderen warten auf den nächsten Stapel.",
  "study.waiting.one": "{n} weiteres Element wartet",
  "study.waiting.other": "{n} weitere Elemente warten",
  "study.batchNotAll": "Dieser Stapel ist fertig, nicht das ganze Konzept: {waiting}.",
  "study.allRounds": "Jeder wartende Eintrag dieses Konzepts wurde dreimal gut beantwortet.",
  "study.nextBatch": "Nächster Stapel",
  "study.conceptCosts": "Das Konzept jetzt anzusehen zählt wie ein Hinweis: Diese Antwort bringt halbe XP.",
  "study.openConcept": "Konzept öffnen",
  "study.dontRemember": "📖 Nicht mehr im Kopf? Lerne dieses Konzept",
  "study.refDrawing": "Die Referenzzeichnung",
  "dispute.title": "Bitte die KI, noch einmal hinzusehen",
  "dispute.testAi": "Die Test-KI kann deinen Einwand nicht lesen: Eine zweite Meinung würde dieselbe Bewertung wiederholen. Bewerte unten selbst.",
  "dispute.why": "Warum bist du anderer Meinung?",
  "dispute.placeholder": "Sag, was die Auswertung falsch gemacht hat…",
  "dispute.hint": "Die KI sieht deinen Einwand und wertet erneut aus. Beide Meinungen bleiben sichtbar; deine Bewertung ändert sich nur, wenn du sie unten wählst.",
  "dispute.asking": "Wird angefragt…",
  "dispute.ask": "Zweite Meinung einholen",
  "eval.correct": "Richtig",
  "eval.complete": "Vollständig",
  "eval.understanding": "Verständnis",
  "eval.precise": "Präzise",
  "eval.Strong": "Stark",
  "eval.Partial": "Teilweise",
  "eval.Weak": "Schwach",
  "eval.scoreBreakdown": "Aufschlüsselung der Punkte",
  "eval.right": "Richtig",
  "eval.missing": "Fehlt",
  "eval.misconception": "Missverständnis",
  "eval.materialSays": "Das Material sagt",
  "eval.covered": "Was deine Antwort abgedeckt hat",
  "eval.failed": "Die Antwort konnte nicht ausgewertet werden.",
  "eval.aiEvaluation": "KI-Auswertung: {verdict}",
  "eval.insufficient": "Das Kursmaterial deckt dies nicht gut genug ab, um es zu bewerten.",
  "eval.testAiTitle": "Test-KI.",
  "eval.testAiBody": "Diese Bewertung stammt von einem Platzhalter, der nur Wörter mit der Referenz vergleicht: Er versteht weder Umschreibungen noch Einwände. Prüfe die Referenz und bewerte selbst oder verbinde eine echte KI.",
  "conceptPanel.title": "Dieses Konzept lernen",
  "conceptPanel.next": "Gelernt – nächste Frage",
  "conceptPanel.closeAria": "Konzept schließen",
  "conceptPanel.loading": "Konzept wird geladen…",
  "conceptPanel.openFull": "Die vollständige Konzeptseite in einem neuen Tab öffnen",
  "dictation.blocked": "Das Mikrofon ist blockiert. Erlaube es in den Website-Einstellungen deines Browsers, um zu diktieren.",
  "dictation.network": "Die Spracherkennung braucht eine Internetverbindung.",
  "dictation.noMic": "Es wurde kein Mikrofon gefunden.",
  "dictation.stopped": "Die Spracherkennung wurde unerwartet beendet. Du kannst weitertippen.",
  "concept.activate": "Aktivieren",
  "concept.activateHelp": "Bereitet die Fragen dieses Konzepts aus deinem Material vor, damit du es lernen kannst.",
  "concept.markStudied": "Als gelernt markieren",
  "concept.markStudiedHelp": "Du hast es woanders gelernt: Es wird vermerkt, ohne schon Fragen vorzubereiten.",
  "concept.activateAgainHelp": "Lernt es erneut: Seine Fragen kommen wieder in deine Sitzungen.",
  "concept.pause": "Pausieren",
  "concept.pauseHelp": "Hält seine Fragen eine Weile an. Nichts geht verloren.",
  "concept.deactivate": "Deaktivieren",
  "concept.deactivateHelp": "Nimmt es aus Lernen und Wiederholungen. Deine Antworten und der Verlauf bleiben erhalten.",
  "concept.resume": "Fortsetzen",
  "concept.resumeHelp": "Bringt seine Fragen zurück in Lernen und Wiederholungen.",
  "concept.sourceDeleted": "Das Material, aus dem dieses Konzept stammt, wurde gelöscht. Behalte, bearbeite oder lösche es.",
  "concept.manage": "Dieses Konzept verwalten",
  "concept.loadingItems": "Lerneinheiten werden geladen…",
  "concept.preparing": "Lerneinheiten werden vorbereitet…",
  "concept.itemsFailed": "Die Lerneinheiten konnten nicht vorbereitet werden.",
  "concept.noSource": "Dieses Konzept hat kein Quellmaterial, aus dem Lerneinheiten erstellt werden könnten.",
  "concept.whatToStudy": "Was zu lernen ist",
  "concept.reviewOwnHelp": "Lass dich jederzeit zu diesem Konzept abfragen. Das ändert deinen Wiederholungsplan nicht und bringt keine XP.",
  "concept.reviewOwn": "🔁 Auf eigene Faust wiederholen",
  "concept.readThen": "Lies sie und drücke dann unten „Ich habe dieses Konzept gelernt“, um sie zu üben.",
  "concept.testMe": "🔁 Frag mich dazu ab",
  "concept.hideDetails": "Details ausblenden",
  "concept.details": "Details",
  "concept.level": "Stufe {n}",
  "concept.markedHard": "Als schwer markiert",
  "concept.notTraining": "Nicht im Training",
  "concept.state": "Zustand",
  "concept.levelLabel": "Stufe",
  "concept.nextReview": "Nächste Wiederholung",
  "concept.reviews": "Wiederholungen",
  "concept.lapses": "Vergessen",
  "concept.inTraining": "Im Training",
  "concept.questions": "Fragen",
  "concept.sourcesTitle": "Quellen",
  "concept.loadingSources": "Quellen werden geladen…",
  "concept.noSources": "Keine Quellenpassagen.",
  "concept.misconceptions": "Wiederkehrende Missverständnisse",
  "drawing.answerBy": "Mit einer Zeichnung antworten",
  "drawing.studentsDraw": "Lernende beantworten diese Frage mit einer Zeichnung. Die KI vergleicht ihre Zeichnung mit dieser.",
  "drawing.youDraw": "Du beantwortest diese Frage mit einer Zeichnung. Die KI vergleicht deine Zeichnung mit dieser.",
  "drawing.referenceAlt": "Referenzzeichnung",
  "drawing.explain": "Für Fragen, die mit einer Zeichnung beantwortet werden (ein Molekül, ein Diagramm, eine Grafik): Füge die richtige Zeichnung hinzu, und die Lernenden zeichnen ihre Antwort, statt sie zu schreiben.",
  "drawing.save": "Diese Zeichnung speichern",
  "drawing.replace": "Durch ein Bild ersetzen…",
  "drawing.upload": "Zeichnung hochladen…",
  "drawing.drawNew": "Neu zeichnen",
  "drawing.drawHere": "Hier zeichnen",
  "drawing.words": "Stattdessen in Worten antworten",
  "drawing.tools": "Zeichenwerkzeuge",
  "drawing.pen": "✏️ Stift",
  "drawing.eraser": "🧽 Radierer",
  "drawing.thick": "Dicke Linie",
  "drawing.thin": "Dünne Linie",
  "drawing.undo": "↶ Rückgängig",
  "drawing.clear": "Löschen",
  "drawing.area": "Zeichenfläche: Zeichne hier deine Antwort",
  "drawing.photoUpload": "Auf Papier gezeichnet? Lade stattdessen ein Foto hoch",
  "drawing.photoError": "Diese Datei ist kein Bild, das dieser Browser lesen kann. Versuche ein JPEG- oder PNG-Foto.",
  "drawing.photoAlt": "Dein Foto der Zeichnung",
  "drawing.drawInstead": "Stattdessen zeichnen",
  "q.title": "Fragen",
  "q.introOwn": "Wähle Fragen aus, um sie zu löschen, zu pausieren, fortzusetzen oder zu verschieben; ziehe ⠿, um sie neu anzuordnen; bearbeite eine, um Titel, Formulierung oder erwartete Antwort zu korrigieren.",
  "q.introManaged": "Dieser Kurs stammt aus dem Marketplace: Sein Autor hält die Fragen aktuell. Wähle Fragen aus, um sie zu pausieren oder fortzusetzen, oder gib ihnen deine eigene Priorität (nur du siehst sie).",
  "q.search": "Fragen suchen",
  "q.searchPlaceholder": "Fragen und Antworten durchsuchen",
  "q.allPriorities": "Alle Prioritäten",
  "q.priorityOnly": "Nur {label} ({n})",
  "q.deselectAll": "Alle abwählen",
  "q.selectAll": "Alle auswählen ({n})",
  "q.selectAllShown": "Alle angezeigten auswählen ({n})",
  "q.collapseAll": "Alle einklappen",
  "q.expandAll": "Alle ausklappen",
  "q.selectedAria": "Ausgewählte Fragen",
  "q.selectedCount": "{n} ausgewählt",
  "q.moveTo": "Verschieben nach…",
  "q.setPriority": "Priorität festlegen",
  "q.setPriorityPlaceholder": "Priorität festlegen…",
  "q.reviewSelectedHelp": "Lass dich jetzt zu den ausgewählten Fragen abfragen. Das ändert deinen Wiederholungsplan nicht und bringt keine XP.",
  "q.clearSelection": "Auswahl aufheben",
  "q.verb.delete": "Gelöscht",
  "q.verb.pause": "Pausiert",
  "q.verb.resume": "Fortgesetzt",
  "q.verb.move": "Verschoben",
  "q.verb.set_priority": "Aktualisiert",
  "unit.question.one": "{n} Frage",
  "unit.question.other": "{n} Fragen",
  "unit.chapter.one": "{n} Kapitel",
  "unit.chapter.other": "{n} Kapitel",
  "unit.topic.one": "{n} Thema",
  "unit.topic.other": "{n} Themen",
  "unit.concept.one": "{n} Konzept",
  "unit.concept.other": "{n} Konzepte",
  "unit.group.one": "{n} geleerte Gruppe",
  "unit.group.other": "{n} geleerte Gruppen",
  "q.newConcepts.one": "{n} neues Konzept",
  "q.newConcepts.other": "{n} neue Konzepte",
  "q.removedConcepts.one": "{n} leeres Konzept entfernt",
  "q.removedConcepts.other": "{n} leere Konzepte entfernt",
  "q.noticeBulk": "{verb}: {questions}{extra}.",
  "q.noticeDeleted": "Gelöscht: {questions}.",
  "q.noticeDeletedGroups": "Gelöscht: {questions} und {groups}.",
  "q.confirmDelete": "{questions} löschen? Ihre Antworten und der Wiederholungsverlauf werden ebenfalls gelöscht.{also}",
  "q.confirmAlso": " Auch {groups}, die keine Fragen mehr haben, werden gelöscht.",
  "q.emptySearch": "Keine Frage passt zu dieser Suche.",
  "q.empty": "Noch keine Fragen. Aktiviere ein Konzept oder importiere deine eigenen Fragen und Antworten.",
  "q.clearToReorder": "Leere die Suche, um diese Fragen neu anzuordnen.",
  "q.select": "Auswählen: {text}",
  "q.otherWordings.one": "+{n} weitere Formulierung",
  "q.otherWordings.other": "+{n} weitere Formulierungen",
  "q.editAria": "Frage bearbeiten",
  "q.titleLabel": "Titel (in Listen angezeigt)",
  "q.wordings": "Formulierungen der Frage",
  "q.wording": "Formulierung {n}",
  "q.addWording": "+ Weitere Formulierung hinzufügen",
  "q.expected": "Erwartete Antwort",
  "q.prio1": "Wesentlich: der Kern, muss man wissen",
  "q.prio2": "Wichtig: sollte man wissen",
  "q.prio3": "Extra: Ergänzung, tieferes Detail",
  "q.keyPoints": "Kernpunkte (einer pro Zeile, bis zu 10)",
  "q.moveAria": "Fragen verschieben",
  "q.moveHeading": "{questions} verschieben nach",
  "q.choose": "Wähle ein Thema oder ein Konzept…",
  "q.topicOption": "Thema: {title} (jede Frage behält ihr eigenes Konzept)",
  "q.conceptOption": "   ↳ in das Konzept: {title}",
  "q.removeEmpty": "Konzepte entfernen, die keine Fragen mehr haben",
  "q.moveHint": "Fragen behalten ihren Wiederholungsfortschritt. In einem nicht aktiven Konzept werden sie erst wiederholt, wenn es aktiv ist.",
  "q.move": "Verschieben",
  "q.groupSelect": "Alle Fragen in {label} auswählen",
  "mat.chapterTitle": "Kapitelmaterial",
  "mat.collapseLabel": "Lernmaterial",
  "mat.files.one": "{n} Datei",
  "mat.files.other": "{n} Dateien",
  "mat.uploading": "Wird hochgeladen…",
  "mat.upload": "Material hochladen",
  "mat.uploadQa": "Fragen & Antworten hochladen",
  "mat.paste": "Text einfügen",
  "mat.howTo": "So bereitest du Fragen & Antworten vor",
  "mat.howToBody": "Lade eine PDF-, Word-, Text- oder Markdown-Datei hoch, in der jede Frage mit „Domanda:“ und die erwartete Antwort mit „Risposta:“ beginnt (oder „Question:“ / „Answer:“), jeweils am Zeilenanfang. Überschriften gruppieren die Fragen zu Themen.",
  "mat.howToBody2": "Jede Frage wird zu einem Konzept, das als nicht gelernt markiert ist, mit deiner Antwort als erwarteter Antwort. Aktiviere es, um mit der Wiederholung zu beginnen. Für den Import wird keine KI verwendet.",
  "mat.loading": "Material wird geladen…",
  "mat.none": "Noch kein Material. Lade PDF-, Word-, PowerPoint-, Text- oder Markdown-Dateien hoch.",
  "mat.file": "Datei",
  "mat.status": "Status",
  "mat.passages": "Passagen",
  "mat.added": "Hinzugefügt",
  "mat.actions": "Aktionen",
  "mat.qa": "F&A",
  "mat.processing": "Wird verarbeitet…",
  "mat.ready": "Bereit",
  "mat.failed": "Fehlgeschlagen",
  "mat.download": "Herunterladen",
  "mat.confirmDelete": "{name} löschen? Daraus erstellte Konzepte werden zur Prüfung markiert.",
  "mat.pasteAria": "Text einfügen",
  "mat.pastePlaceholder": "z. B. Notizen zur Vorlesung 3",
  "mat.thisTextIs": "Dieser Text ist",
  "mat.asMaterial": "Lernmaterial",
  "mat.asQa": "Fragen & Antworten (Domanda: / Risposta:)",
  "mat.text": "Text",
  "mat.textPlaceholderQa": "# Thema\nDomanda: …?\nRisposta: …",
  "mat.textPlaceholder": "# Überschrift\nDeine Notizen…",
  "mat.adding": "Wird hinzugefügt…",
  "mat.addText": "Text hinzufügen",
  "mat.pastedName": "Eingefügter Text {when}",
  "prop.title": "Vorgeschlagener Lehrplan",
  "prop.reading": "Die KI liest dein Material…",
  "prop.applied": "Dieser Vorschlag wurde bereits angewendet.",
  "prop.failed": "Die KI konnte keinen Lehrplan vorschlagen.",
  "prop.blank": "Jedes Kapitel, Thema und Konzept braucht einen Titel.",
  "prop.longMaterial": "Das Material war lang: Dies deckt die ersten {used} von {total} Passagen ab.",
  "prop.dropped": "{n} vorgeschlagene Konzepte wurden weggelassen, weil sie sich nicht mit deinem Material verknüpfen ließen.",
  "prop.hint": "Bearbeite alles unten: umbenennen, neu anordnen, Konzepte zwischen Themen verschieben, zusammenführen, löschen oder hinzufügen. Nichts wird aktiviert: Was du danach lernst, entscheidest du.",
  "prop.chapterTitle": "Kapiteltitel",
  "prop.deleteChapter": "Kapitel löschen",
  "prop.accept": "Lehrplan annehmen",
  "prop.reject": "Vorschlag ablehnen",
  "prop.topicAria": "Thema {title}",
  "prop.existingTopic": "vorhandenes Thema",
  "prop.topicTitle": "Thementitel",
  "prop.moveTopicUp": "Thema nach oben",
  "prop.moveTopicDown": "Thema nach unten",
  "prop.deleteTopic": "Thema löschen",
  "prop.conceptTitle": "Konzepttitel",
  "prop.exists": "existiert bereits",
  "prop.moveConceptUp": "Konzept nach oben",
  "prop.moveConceptDown": "Konzept nach unten",
  "prop.moveToTopic": "In Thema verschieben",
  "prop.untitled": "Thema ohne Titel",
  "prop.merge": "Mit nächstem zusammenführen",
  "prop.addConcept": "+ Konzept hinzufügen",
  "mkt.intro": "Kurse anderer LEARNABLE-Nutzer. Füge einen deinen Kursen hinzu und lerne ihn mit deinem eigenen Plan: Sein Autor hält ihn aktuell. Um einen eigenen zu teilen, öffne ihn und fülle seine „Marktplatz-Seite“ aus.",
  "mkt.categories": "Kategorien",
  "mkt.all": "Alle",
  "mkt.searchPlaceholder": "Nach Titel oder Beschreibung suchen",
  "mkt.level": "Niveau",
  "mkt.language": "Sprache",
  "mkt.size": "Umfang",
  "mkt.sort": "Sortieren",
  "mkt.any": "Beliebig",
  "mkt.loading": "Kurse werden geladen…",
  "mkt.noMatch": "Noch kein Kurs passt zu diesen Filtern.",
  "mkt.publishedByMe": "Von mir veröffentlicht",
  "mkt.status.DRAFT": "Entwurf",
  "mkt.status.PUBLISHED": "Veröffentlicht",
  "mkt.status.UNPUBLISHED": "Nicht veröffentlicht",
  "mkt.version": "Version {n}",
  "mkt.students.one": "{n} Lernender",
  "mkt.students.other": "{n} Lernende",
  "mkt.editCourse": "Kurs und Seite bearbeiten",
  "mkt.by": "von {author}",
  "mkt.inYourCourses": "In deinen Kursen",
  "mkt.loadingCourse": "Kurs wird geladen…",
  "mkt.updated": "aktualisiert am {date}",
  "mkt.statStudents": "Lernende",
  "mkt.yourCourse": "Dein Kurs",
  "mkt.draftTag": "Entwurf",
  "mkt.notPublishedTag": "nicht veröffentlicht",
  "mkt.open": "In meinen Kursen öffnen",
  "mkt.addBack": "Wieder zu meinen Kursen hinzufügen",
  "mkt.add": "Zu meinen Kursen hinzufügen · {price}",
  "mkt.about": "Über diesen Kurs",
  "mkt.learn": "Was du lernen wirst",
  "mkt.audience": "Für wen er ist",
  "mkt.hiddenNote": "Die Fragen und Antworten werden sichtbar, sobald der Kurs in deinen Kursen ist. Du lernst sie innerhalb von LEARNABLE: Das Material des Autors kann nicht heruntergeladen werden.",
  "sales.originTitle": "🛒 Aus dem Marktplatz",
  "sales.madeBy": "Erstellt von {author} (Version {version}). Der Autor hält Kapitel, Fragen und Antworten aktuell, daher kannst du sie hier nicht bearbeiten: Aktualisierungen kommen automatisch bei dir an.",
  "sales.yourStudy": "Dein Lernen gehört dir: Konzepte aktivieren, pausieren, deine Antworten, dein Wiederholungsplan und XP sowie die Priorität, die du jeder Frage gibst (nur du siehst sie).",
  "sales.seePage": "Seine Marktplatz-Seite ansehen",
  "sales.title": "🛒 Marktplatz-Seite",
  "sales.pPublished": "Veröffentlicht · Version {n}",
  "sales.pNot": "Nicht veröffentlicht",
  "sales.pDraft": "Entwurf",
  "sales.pNone": "Nicht geteilt",
  "sales.explain": "Teile diesen Kurs mit anderen Nutzern. Hier schreibst du seine Seite, das Einzige, was Leute vor dem Hinzufügen sehen: was er abdeckt, für wen er ist, was sie lernen werden. Sie sehen auch die Kapiteltitel und wie viele Fragen es gibt; die Fragen selbst erst, wenn sie den Kurs haben, und dein hochgeladenes Material nie.",
  "sales.seeAsOthers": "So sehen es andere",
  "sales.edit": "Marktplatz-Seite bearbeiten",
  "sales.write": "Marktplatz-Seite schreiben",
  "sales.subtitle": "Untertitel",
  "sales.subtitleHint": "(eine Zeile, z. B. „Alle 300 Fragen der mündlichen Prüfung, mit Musterantworten“)",
  "sales.category": "Kategorie",
  "sales.description": "Beschreibung",
  "sales.descriptionHint": "(was er abdeckt, wie du ihn gemacht hast, wie man ihn nutzt)",
  "sales.outcomes": "Was Lernende lernen werden",
  "sales.outcomesHint": "(eins pro Zeile, bis zu 8)",
  "sales.tags": "Tags",
  "sales.tagsHint": "(durch Kommas getrennt, bis zu 8)",
  "sales.saveDraft": "Entwurf speichern",
  "sales.savePage": "Seite speichern",
  "sales.publish": "Veröffentlichen",
  "sales.publishUpdate": "Aktualisierung veröffentlichen",
  "sales.publishHintUpdate": "Sendet deine aktuellen Kapitel, Fragen und Antworten an alle, die den Kurs haben. Ihr eigener Fortschritt bleibt erhalten.",
  "sales.publishHint": "Macht den Kurs im Marktplatz sichtbar. Vorerst ist er kostenlos. Du kannst ihn weiter bearbeiten und später Aktualisierungen veröffentlichen.",
  "sales.rights": "Die Fragen und Antworten darf ich teilen (ich habe sie selbst geschrieben oder habe die Rechte am Material, aus dem sie stammen).",
  "sales.publishing": "Wird veröffentlicht…",
  "sales.publishUpdateBtn": "Aktualisierung veröffentlichen",
  "sales.unpublish": "Veröffentlichung zurückziehen",
  "sales.noteSaved": "Gespeichert: Die Marktplatz-Seite zeigt es jetzt.",
  "sales.noteDraft": "Entwurf gespeichert. Niemand sonst sieht ihn, bis du veröffentlichst.",
  "sales.notePublishedV": "Version {n} veröffentlicht: Alle, die den Kurs haben, erhalten jetzt deine neuesten Fragen.",
  "sales.notePublished": "Veröffentlicht! Andere Nutzer finden ihn jetzt im Marktplatz.",
  "sales.noteUnpublished": "Zurückgezogen: Neue Nutzer finden ihn nicht mehr. Wer ihn schon hat, behält ihn.",
  "prog.empty": "Erstelle einen Kurs und beginne zu lernen, um deinen Fortschritt zu sehen.",
  "prog.weakConcepts": "Schwache Konzepte",
  "prog.weakMeta": "Vergessen: {lapses} · als schwer markiert: {hard}",
  "prog.byChapter": "Nach Kapitel und Thema",
  "prog.colChapter": "Kapitel / Thema",
  "weak.intro": "In deinen letzten Antworten gefundene Fehler, nach Konzept. Sie verschwinden, sobald deine letzten Antworten auf das Element sie nicht mehr zeigen. Übung ändert deinen Wiederholungsplan nicht.",
  "weak.loading": "Deine letzten Antworten werden angesehen…",
  "weak.empty": "Im Moment keine wiederkehrenden Fehler. Antworte weiter, dann erscheinen sie hier.",
  "weak.practiceTop.one": "Übe das wichtigste Konzept ({n})",
  "weak.practiceTop.other": "Übe die wichtigsten {n} Konzepte",
  "weak.practiceThis": "Das üben",
  "weak.seen.one": "{n} Mal gesehen, zuletzt {date}",
  "weak.seen.other": "{n} Mal gesehen, zuletzt {date}",
  "home.intro": "Geplante Wiederholungen bewahren, was du gelernt hast. Fällige Zahlen folgen denselben Regeln wie eine Wiederholungssitzung.",
  "home.noCourses": "Noch keine Kurse.",
  "home.createOnDashboard": "Erstelle einen in deinem Dashboard",
  "home.meta": "{due} jetzt fällig · {introduced} von {trained} Elementen eingeführt",
  "activity.pageIntro": "Abgeschlossene Antworten pro Tag im letzten Jahr, in deiner Zeitzone. Eine Antwort zählt, sobald sie eine endgültige Bewertung hat, ob richtig oder falsch.",
  "reset.title": "Passwort zurücksetzen",
  "reset.intro": "Gib die E-Mail deines Kontos ein. Wir senden dir einen Link, um ein neues Passwort zu wählen; er funktioniert einmal, 30 Minuten lang.",
  "reset.send": "Link zum Zurücksetzen senden",
  "reset.sentMessage": "Falls ein Konto mit dieser E-Mail existiert, ist ein Link zum Zurücksetzen des Passworts unterwegs. Prüfe deinen Posteingang (und den Spam-Ordner).",
  "reset.back": "Zurück zur Anmeldung",
  "reset.chooseTitle": "Neues Passwort wählen",
  "reset.incomplete": "Dieser Link ist unvollständig. Öffne den Link aus der E-Mail erneut oder fordere einen neuen an.",
  "reset.done": "Dein Passwort wurde geändert. Alle Geräte wurden abgemeldet: Melde dich mit dem neuen Passwort an.",
  "reset.newPassword": "Neues Passwort",
  "reset.repeat": "Neues Passwort wiederholen",
  "reset.tooShort": "Verwende mindestens {n} Zeichen.",
  "reset.mismatch": "Die beiden Passwörter stimmen nicht überein.",
  "reset.set": "Neues Passwort festlegen",
  "source.aria": "Quellenpassage",
  "source.closeAria": "Quelle schließen",
  "source.loading": "Passage wird geladen…",
  "source.open": "Quellenpassage öffnen",
  "course.loadingCurriculum": "Lehrplan wird geladen…",
  "mkt.addPlain": "Zu meinen Kursen hinzufügen",
  "sales.pageName": "Marktplatz-Seite",
};
